<template>
  <button
    v-show="isVisible"
    @click="scrollToTop"
    class="scroll-to-top"
    title="go to up"
  >
    ⬆
  </button>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const isVisible = ref(false)

const toggleVisibility = () => {
  isVisible.value = window.scrollY > 200
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => {
  window.addEventListener('scroll', toggleVisibility)
})

onUnmounted(() => {
  window.removeEventListener('scroll', toggleVisibility)
})
</script>

<style scoped>
.scroll-to-top {
  position: fixed;
  bottom: 40px;
  right: 40px;
  background-color: rgb(228, 31, 43);
  color: white;
  border: none;
  padding: 12px 16px;
  border-radius: 50%;
  font-size: 18px;
  cursor: pointer;
  z-index: 1000;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
}
.scroll-to-top:hover {
  background-color: rgb(228, 31, 43);
}
</style>
